export const AUD_MOBILE_BANNER_TO_APP = 'aud_mobile_ADSC385_banner_to_app_listing_v2';

export const AUD_MOBILE_BOTTOM_NAVIGATION_EXPERIMENT = 'vx_mobweb_bx_349_bottom_navigation_v2';

export const AUD_DESKTOP_MENU = 'aud_desktop_bx606_new_head_menu';

export const EXPERIMENTS = [AUD_MOBILE_BANNER_TO_APP, AUD_MOBILE_BOTTOM_NAVIGATION_EXPERIMENT, AUD_DESKTOP_MENU];
